import React from 'react'; 
import ArticleThumb from './ArticleThumb';
import WithConsumer from '../context/WithConsumer';
import Foot from './Foot';

const Articles = ({context}) => {
    const posts = () => context.posts;
    const item = posts()[0];  
		 
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
	const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
    
    let pageClass = 'c-page-wrapper state-not-loaded';
    if (pageLoaded == true) {
	    pageClass = 'c-page-wrapper state-loaded';
    }
    
	if (item && doRender) {
		let title;
		if (item.title) {
			title = <h1 className="c-collection__heading">{ item.title }</h1>
		} else {
			title = '';
		}
		let thumbs = null;
	    if (item.thumbs) {
		    thumbs = item.thumbs.map((thumb,i) =>
			    <ArticleThumb thumb={thumb} key={i}></ArticleThumb>
			);
	    }

	    return (
		    <div className={pageClass}>
		        <div className="c-collection">
		        	{ title }		        	
		        	<div className="c-articles c-articles--collection">
		        		{ thumbs }
		        	</div>
		        </div>
		        <Foot></Foot>
	        </div>
		);
	}
	return '';

};
export default WithConsumer(Articles);